import { useState, useCallback } from 'react';
import { useTaxProfiles } from '~/modules/clients/client/ClientInfo/dialogs/billing/hooks';

export const useTaxProfileOptions = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const handleInputChange = useCallback((_, v) => setSearchTerm(v), []);

  const { loading, taxProfiles } = useTaxProfiles({
    searchTerm
  });

  return {
    loading,
    taxProfiles,
    handleInputChange
  };
};

export default useTaxProfileOptions;
